import classnames from 'classnames'
import styles from './HomeProductList.module.scss'
import HomeProductListWarpBg, {
  WARP_BG_ANIMATION_DURATION,
} from '@/sections/HomeProductList/HomeProductListWarpBg/HomeProductListWarpBg'
import HomeProductListTransitionBoxes from '@/sections/HomeProductList/HomeProductListTransitionBoxes/HomeProductListTransitionBoxes'
import { useEffect, useRef, useState } from 'react'
import useStore from '@/store'
import gsap from 'gsap'
import HomeProductPanningContainer from '@/sections/HomeProductList/HomeProductPanningContainer/HomeProductPanningContainer'
import { deviceInfo } from '@/utils'

const HomeProductList = ({ className, products }) => {
  const $warpBg = useRef()
  const $transitionBoxes = useRef()
  const $panningContainer = useRef()
  const loaderAnimationComplete = useStore(state => state.loaderAnimationComplete)
  const prevPath = useStore(state => state.prevPath)
  const hasAnimated = useRef(false)
  const [homepageCalculated, setHomepageCalculated] = useState(false)

  useEffect(() => {
    if (!loaderAnimationComplete || !$warpBg.current || !$transitionBoxes.current || !homepageCalculated) return

    if (hasAnimated.current) return

    hasAnimated.current = true

    const isSafariDesktop = deviceInfo?.isSafariDesktop

    const setupRaf = () => {
      if ($panningContainer?.current?.scaleOffsetMasterMultiplier) {
        gsap.killTweensOf($panningContainer.current.scaleOffsetMasterMultiplier.current)
        gsap.to($panningContainer.current.scaleOffsetMasterMultiplier, {
          current: 1,
          duration: 1,
        })
      }
    }

    const animateAllCardsExceptTop = () => {
      $panningContainer.current.animateBoxesIntoPlace(null, false)
    }

    const animateTopCard = () => {
      $panningContainer.current.animateBoxesIntoPlace(null, true)
    }

    const warpHide = callback => {
      $warpBg.current.visuallyHide(() => {
        $warpBg.current.setRender(false)
        if (callback) callback()
      })
    }

    let timeout = prevPath ? 300 : 100
    if (isSafariDesktop) {
      timeout = 0
    }

    setTimeout(() => {
      if (!$panningContainer.current) return

      if (isSafariDesktop) {
        setTimeout(() => {
          warpHide()
          setupRaf()
          animateTopCard()
        }, 10)
      } else {
        $panningContainer.current.setBoxInitialPositions()
        $warpBg.current.animateOut(() => {
          warpHide(() => {
            setupRaf()
            animateTopCard()
          })
        })
      }

      let animateTimeout = WARP_BG_ANIMATION_DURATION * 1000 * 0.33
      if (isSafariDesktop) {
        animateTimeout = 0
      }

      setTimeout(() => {
        animateAllCardsExceptTop()
      }, animateTimeout)
    }, timeout)
  }, [loaderAnimationComplete, prevPath, homepageCalculated])

  return (
    <div className={classnames(styles.HomeProductList, className)}>
      <div className={styles.inner}>
        <HomeProductListWarpBg ref={$warpBg} />
        <HomeProductPanningContainer
          onCalculationsSetCallback={() => {
            setHomepageCalculated(true)
          }}
          products={products}
          ref={$panningContainer}
          transitionBoxesRef={$transitionBoxes}
        >
          <HomeProductListTransitionBoxes ref={$transitionBoxes} />
        </HomeProductPanningContainer>
      </div>
    </div>
  )
}

HomeProductList.displayName = 'HomeProductList'

export default HomeProductList
